import * as React from 'react';

import { useTracker } from '@coursera/event-pulse/react';

import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';
import LearnMoreLink from 'bundles/unified-description-page-common/components/shared/LearnMoreLink';
import { CREDITS_ANCHOR_ID } from 'bundles/unified-description-page-common/constants';
import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';
import type { DegreeFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';
import getUpsellCaption from 'bundles/unified-description-page-common/utils/getUpsellCaption';

import _t from 'i18n!nls/xdp';

const KeyInformationStackability = ({
  degrees,
  disableCta,
}: {
  degrees?: DegreeFragment[] | null;
  disableCta?: boolean;
}) => {
  const eventingProductData = useEventingProductData();
  const track = useTracker();

  return (
    <KeyInformationDetailsItem
      title={getUpsellCaption(degrees || [])}
      subtitle={
        !disableCta && (
          <LearnMoreLink
            trackingName="kim_degree_details_link"
            href={`#${CREDITS_ANCHOR_ID}`}
            ariaLabel={_t('Learn more about degree credit')}
            onClick={() => {
              track('click_button', {
                button: {
                  name: 'description_page_degree_details',
                },
                pageSection: {
                  sectionName: 'kim',
                },
                ...eventingProductData,
              });
            }}
          />
        )
      }
    />
  );
};

export default KeyInformationStackability;
